import { render } from "./GaleriaComp.vue?vue&type=template&id=46d1ea19&scoped=true"
import script from "./GaleriaComp.vue?vue&type=script&lang=js"
export * from "./GaleriaComp.vue?vue&type=script&lang=js"

import "./GaleriaComp.vue?vue&type=style&index=0&id=46d1ea19&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46d1ea19"]])

export default __exports__